import {
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  LinearProgress,
  Typography,
  withStyles,
  withWidth,
} from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import ReactHtmlParser from "react-html-parser";
import Img from "../../../components/Img";
import { formatCurrency } from "../../../components/Utils/Currency";
import "../style.css";
import FormatNumber from "../../../components/Utils/formatcuRupiah";
const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 4,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

// INI DETAIL KETIKA DI KLIK ->

// PROP MEMBAWA DATA DARI PILIHAN SEBELUMNYA
const Detail = (props) => {
  const {
    width,
    data,
    access,
    deleted,
    handleShowForm,
    handleDelete,
    handleGetVoucherList,
  } = props;
  const [openDialog, setOpenDialog] = React.useState(true);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  // console.log(access);
  const handleEdit = () => {
    handleShowForm(data);
    handleCloseDialog();
  };

  const handleDeleteData = () => {
    handleDelete(data.id);
    handleCloseDialog();
  };

  return (
    // PEMBUNGKUS
    <Dialog
      disableBackdropClick
      maxWidth={width !== "xs" ? "sm" : false}
      fullScreen={width === "xs"}
      scroll="body"
      open={openDialog}
    >
      <DialogContent className="dialog-content-voucher">
        <Grid
          container
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            padding: 16,
            display: "flex",
          }}
          justify="space-between"
          alignItems="center"
        >
          <IconButton
            aria-label="close"
            className="icon-button-voucher"
            onClick={handleCloseDialog}
          >
            <ArrowBackIcon />
          </IconButton>

          {/* BUTTON EDIT DAN DELETE DI ATAS CARD */}
          <div>
            {access?.patch && !deleted && (
              <IconButton
                aria-label="edit"
                className="icon-button-voucher"
                onClick={() => {
                  handleEdit();
                }}
                style={{ marginRight: 16 }}
              >
                <EditIcon />
              </IconButton>
            )}
            {access?.delete && !deleted && (
              <IconButton
                aria-label="delete"
                className="icon-button-voucher"
                onClick={handleDeleteData}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </div>
          {/* END EDIT DELETE CARD */}
        </Grid>

        {/* iSI CARD */}
        <Grid container>
          <Grid item xs={12}>
            {data.image_voucher === "" ? (
              <>
                <div style={{ width: "100%", textAlign: "center" }}>
                  <h1 style={{ padding: "7rem" }}>no image</h1>
                </div>
              </>
            ) : (
              <Img
                src={data.image_voucher}
                alt={data.name}
                style={{ width: "100%" }}
              />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "start",
              padding: 20,
            }}
          >
            <div
              style={{
                marginLeft: 12,
                display: "flex",
                flexDirection: "column",
                lineHeight: 1,
              }}
            >
              <span
                style={{
                  fontSize: 11,
                  fontWeight: "bold",
                  color: "#212121",
                  margin: 0,
                }}
              >
                {data.property.name}
              </span>
              <h5
                style={{
                  fontWeight: "lighter",
                  fontSize: 20,
                  color: "#212121",
                  margin: "12px 0px",
                }}
              >
                {data.code}
              </h5>
              <h6
                style={{
                  fontWeight: "bold",
                  fontSize: 16,
                  color: "#2196F3",
                  margin: 0,
                }}
              >
                {data.name}
              </h6>
            </div>
          </Grid>
          <div
            style={{
              flexGrow: 1,
              padding: 20,
              borderTop: "1px solid #EEEEEE",
            }}
          >
            <BorderLinearProgress
              variant="determinate"
              value={(data.stock / data.quota) * 100}
            />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 12,
              }}
            >
              <span style={{ fontSize: 10, color: "#BDBDBD" }}>
                Currently available
              </span>
              <span
                style={{ fontSize: 10, fontWeight: "bolder", color: "#212121" }}
              >
                {}
              </span>
            </div>
          </div>
        </Grid>
        <Grid container style={{ padding: 20 }}>
          <Grid item xs={12}>
            <div
              style={{
                padding: 8,
                backgroundColor: "#EEEEEE",
                color: "#2196F3",
                fontWeight: "bold",
                fontSize: 11,
                display: "inline-block",
              }}
            >
              {data.type.name}
            </div>
          </Grid>
          <Grid item xs={12}>
            <h6
              style={{
                fontSize: 18,
                marginTop: 16,
                marginBottom: 0,
                fontWeight: "bold",
                color: "#212121",
              }}
            >
              Expired date voucher
            </h6>
            <div className="voucher-detail">
              {moment(data.end_date)
                .tz(data.property.timezone || "Asia/Jakarta")
                .format("DD - MM - YYYY")}
            </div>
            <h6
              style={{
                fontSize: 18,
                marginTop: 16,
                marginBottom: 0,
                fontWeight: "bold",
                color: "#212121",
              }}
            >
              Description
            </h6>
            <div className="voucher-detail">
              {ReactHtmlParser(data.description)}
            </div>
            <h6
              style={{
                fontSize: 18,
                marginTop: 16,
                marginBottom: 0,
                fontWeight: "bold",
                color: "#212121",
              }}
            >
              Terms &amp; condition
            </h6>
            <div className="voucher-detail">{ReactHtmlParser(data.snk)}</div>
            <h6
              style={{
                fontSize: 18,
                marginTop: 16,
                marginBottom: 0,
                fontWeight: "bold",
                color: "#212121",
              }}
            >
              Value Voucher
            </h6>
            <div className="voucher-detail">
              Rp {FormatNumber(`${data.value_voucher}`)}
            </div>
            <h6
              style={{
                fontSize: 18,
                marginTop: 16,
                marginBottom: 0,
                fontWeight: "bold",
                color: "#212121",
              }}
            >
              Max Used
            </h6>
            <div className="voucher-detail">
              {FormatNumber(`${data.max_used}`)}
              {/* {data.value.max_used} */}
            </div>
            {data.tenant ? (
              <h6
                style={{
                  fontSize: 18,
                  marginTop: 16,
                  marginBottom: 10,
                  fontWeight: "bold",
                  color: "#212121",
                }}
              >
                Tenant
              </h6>
            ) : null}
            {data.tenant &&
              data.tenant.map((e, index2) => {
                return (
                  <div
                    class="alert alert-info d-flex justify-content-between align-items-center"
                    role="alert"
                  >
                    <img
                      src={e.logo.square}
                      style={{
                        width: "3rem",
                        height: "3rem",
                        marginRight: "1rem",
                      }}
                      alt=""
                    />
                    <div>{e.name}</div>
                    <div onClick={() => {}}></div>
                  </div>
                );
              })}
            {data.delivery_package && (
              <h6
                style={{
                  fontSize: 18,
                  marginTop: 16,
                  marginBottom: 10,
                  fontWeight: "bold",
                  color: "#212121",
                }}
              >
                Package Delivery
              </h6>
            )}
            {data.delivery_package &&
              data.delivery_package.map((e, index2) => {
                return (
                  <div
                    class="alert alert-info d-flex justify-content-between align-items-center"
                    role="alert"
                  >
                    <div>{e.name}</div>
                    <div onClick={() => {}}></div>
                  </div>
                );
              })}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

Detail.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
  handleGetVoucherList: PropTypes.func,
};
export function showDetail(
  data,
  access,
  deleted,
  handleShowForm,
  handleDelete,
  handleGetVoucherList,
  options = {}
) {
  return createConfirmation(confirmable(withWidth()(Detail)))({
    data,
    access,
    deleted,
    handleShowForm,
    handleDelete,
    handleGetVoucherList,
    ...options,
  });
}
